import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/CloseRounded";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import "react-country-dropdown/dist/index.css";
import { useLocation } from "react-router-dom";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import store from "../../store/reducers/rootReducer";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  paper: {

    background: "var(--backgroundcolor)",
    color: "white"
  },
  control: {
    // padding: "2%",
    // marginBottom: "2%",
    backgroundColor: 'var(--white)',
    // [theme.breakpoints.down("sm")]: {
    //   padding: "4%",
    // },
  },
  main: {
    paddingTop: "10%",
    backgroundColor: "rgb(246, 249, 252)",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "32%",
    },
  },
  textField: {
    borderRadius: '5px',
    backgroundColor: 'var(--backgroundcolor)',
    padding: '2px 10px'
  },
  input: {
    color: 'var(--darker)'
  },
  datePicker: {
    '& .MuiPickersModal-dialog': {
      backgroundColor: 'var(--dark) !important'
    },
    '& .MuiDialogActions-spacing ': {
      backgroundColor: 'var(--darker) !important'
    },
    '& .MuiDialogActions-spacing .MuiButton-label': {
      color: 'var(--darker)'
    },
    '& .MuiPickersModal-dialog .MuiPickersBasePicker-container .MuiToolbar-root': {
      backgroundColor: 'var(--darker)  !important'
    },
    '& .MuiPickersBasePicker-container .MuiPickersBasePicker-pickerView .MuiPickersDay-day ': {
      color: 'var(--darker)'
    },
    '& .MuiPickersBasePicker-container .MuiButtonBase-root.MuiIconButton-root.MuiPickersDay-day.MuiPickersDay-dayDisabled ': {
      color: 'var(--backgroundcolor)'
    },

    '& .MuiPickersBasePicker-container .MuiPickersCalendarHeader-iconButton ': {
      color: 'var(--darker)',
      backgroundColor: 'var(--white)',
      padding: '7px',
      margin: '0px 5px'
    }
    ,
    '& .MuiPickersCalendarHeader-switchHeader p,.MuiTypography-root.MuiPickersCalendarHeader-dayLabel.MuiTypography-caption': {
      color: 'var(--darker) '

    }
  },
  pickerInput: {
    backgroundColor: 'var(--backgroundcolor)',
    color: 'var(--darker)',
    padding: '3px',
    borderRadius: '5px',
    '&.hover': {
      border: 'none',
      outline: 'none'
    }
  },
}));

const titleOptions = [
  { value: "mr", label: "Mr." },
  { value: "ms", label: "Ms." },
];
const categoryOptions = [
  { value: "adult", label: "Adult" },
  { value: "child", label: "Child" },
  { value: "infant", label: "Infant" },
];

const ageLimits = {
  adult: { min: 18, max: 100 },
  infant: { min: 0, max: 2 },
  child: { min: 2, max: 18 }
}






function PassengerListItem(props) {
  const classes = useStyles();
  const { id } = props.data;
  const { data } = props;
  const search = useLocation().search;
  const departureDate = new URLSearchParams(search).get("departureDate");
  const flight = useSelector(state => state.flight.selectedFlight)

  let minDate;
  let maxDate;
  switch (data.category) {
    case "adult":
      minDate = moment().subtract(100, "years");
      maxDate = moment().subtract(18, "years");
      break;
    case "child":

      minDate = moment().subtract(17, "years").subtract(11, "months");
      maxDate = moment().subtract(2, "years");
      break;
    case "infant":
      minDate = moment().subtract(2, "years");
      maxDate = moment()
      break;
  }
  const dispatch = useDispatch();

  const setPassengers = (data) => {
    dispatch({ type: "SET_PASSENGERS", data });
  };

  const removePassenger = (id) => {
    const { passengers } = store.getState().flight;
    let _passengers = [...passengers];
    const ind = _passengers.findIndex((passenger) => passenger.id === id);
    _passengers.splice(ind, 1);
    setPassengers(_passengers);
  };

  const validationSchema = Yup.array().of(Yup.object().shape({
    title: Yup.string().required("Required"),
    category: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
    surname: Yup.string().required("Required"),
    birthday: Yup.date().required("Required"),
    nationality: Yup.string().required("Required"),
    email: Yup.string().email().required('Required'),
    phone: Yup.string().min(10).required('Required'),
  }));

  const onChange = async (key, value) => {
    props.onChange(value, key, props.roomNumber, props.index)
  };

  const handleBaggageChange = (data) => {
    if (data) {
      const { passengers } = store.getState().flight;
      let _passengers = [...passengers];
      const ind = _passengers.findIndex((pass) => pass.id === id);
      const obj = { ..._passengers[ind] };
      obj['baggage'] = data;
      _passengers[ind] = obj;
      setPassengers(_passengers);
    }
  }


  return (
    <Paper className={classes.control} elevation={0}>
      <Grid container style={{ paddingTop: "10px" }} className="passenger-box" spacing={0}>
        
        <Grid item xs="12" sm="6" className="p-10">
          <Typography component="p" style={{ textAlign: 'left' }}>First Name <sup>*</sup></Typography>

          <TextField
            size="small"
            fullWidth
            value={data?.Name?.First}
            id="outlined-error-helper-text"
            className={classes.textField}
            InputProps={{
              className: classes.input,
              disableUnderline: true
            }}
            onChange={(e) => {
              onChange('First', e.target.value);
              //setName(e.target.value)
            }}
          />


        </Grid>
        <Grid item xs="12" sm="6" className="p-10">
          <Typography component="p" style={{ textAlign: 'left' }}>Surname <sup>*</sup></Typography>
          <TextField
            size="small"
            className={classes.textField}
            InputProps={{
              className: classes.input,
              disableUnderline: true
            }}
            fullWidth
            value={data?.Name?.Last}
            id="outlined-error-helper-text"

            onChange={(e) => {
              onChange('Last', e.target.value);
              // setSurname(e.target.value)
            }}
          />

        </Grid>
        
        
      </Grid>
    </Paper>
  );
}

export default React.memo(PassengerListItem);
